import script from "./AgentChatDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentChatDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./AgentChatDrawer.vue?vue&type=style&index=0&id=6d62a0c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d62a0c0"]])

export default __exports__